import { render, staticRenderFns } from "./menuPage.vue?vue&type=template&id=a5b752a6&scoped=true"
import script from "./menuPage.vue?vue&type=script&lang=js"
export * from "./menuPage.vue?vue&type=script&lang=js"
import style0 from "./menuPage.vue?vue&type=style&index=0&id=a5b752a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b752a6",
  null
  
)

export default component.exports